<template>
  <div class="rejectedList">
    <el-dialog
      width="600px"
      title="驳回原因"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body>
        <el-table :data="list" border style="margin-top: 10px">
          <el-table-column align="center" label="操作时间" prop="lastUpdateDate" width="170"></el-table-column>
          <el-table-column align="center" label="驳回原因" prop="reason"></el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px; text-align: center;"
          :current-page="filter.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="filter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
    </el-dialog>
  </div>
</template>

<script>
import { getRejectedList } from "@/api/organization";
export default {
  name: 'RejectedList',
  data () {
    return {
      innerVisible: false,
      filter: {
        contractId: null,
        page: 1,
        limit: 10,
      },
      list: [],
      total: 0
    }
  },
  methods: {
    init(row) {
      this.filter.contractId = row.id
      this.getList()
      this.innerVisible = true
    },
    async getList() {
      const res = await getRejectedList(this.filter)
      this.list = res.data.records
      this.total = +res.data.total
    },
    // // 搜索
    // search() {
    //   this.filter.page = 1
    //   this.getList()
    // },
    // // 重置
    // reset() {
    //   Object.keys(this.filter).forEach(key => {
    //     this.filter[key] = null
    //   })
    //   this.filter.page = 1
    //   this.filter.limit = 10
    //   this.getList()
    // },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
